import { GLOBAL_PREFIX } from '@/router/constants';

const PREFIX = `${GLOBAL_PREFIX}/partner`;
const PartnerHomeView = () => import('@/views/partner/PartnerHomeView.vue');

// The partner environment. Its other menu items (AI assistant, documents,
// company profile) are the organisation screens, with the partner as the
// active organisation.
const routes = [
  {
    path: `${PREFIX}/`,
    name: 'partner-home',
    component: PartnerHomeView,
    meta: {
      title: 'word.brands',
      app: 'organisation',
      // The landing is the overview of the brands, so "Mijn merken" lights up.
      navRouteActive: 'partner-brands',
      hideBreadcrumbs: true,
    },
  },
  {
    // The same overview for now; the dashboard may show more than the brands
    // later on, this stays the list of brands.
    path: `${PREFIX}/brands/`,
    name: 'partner-brands',
    component: PartnerHomeView,
    meta: {
      title: 'word.brands',
      app: 'organisation',
      navRouteActive: 'partner-brands',
      hideBreadcrumbs: true,
    },
  },
  {
    // The researches of all the partner's brands.
    path: `${PREFIX}/researches/`,
    name: 'partner-researches',
    component: () => import('@/views/partner/PartnerResearchListView.vue'),
    meta: {
      title: 'word.researches',
      app: 'organisation',
      navRouteActive: 'partner-researches',
    },
  },
  {
    // A research is always requested for a brand, so this asks which one first.
    path: `${PREFIX}/request-research/`,
    name: 'partner-request-research',
    component: PartnerHomeView,
    meta: {
      title: 'phrase.request_research',
      app: 'organisation',
      navRouteActive: 'partner-request-research',
      hideBreadcrumbs: true,
      partnerIntent: 'request-research',
    },
  },
];

export default routes;
